import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';
import { Typography, Card, CardContent, Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const GaugeChart = ({
  value,
  label,
  subtitle,
  thresholds = { red: 30, orange: 60, green: 100 },
  invertColors = false
}) => {
  const theme = useTheme();

  const getColor = (val) => {
    if (invertColors) {
      // Pour churn: valeur haute = mauvais
      if (val > 20) return '#f44336';  // Rouge si > 20%
      if (val > 10) return '#ff9800';  // Orange si > 10%
      return '#4caf50';                 // Vert sinon
    }
    // Normal: valeur basse = mauvais
    if (val < thresholds.red) return '#f44336';
    if (val < thresholds.orange) return '#ff9800';
    return '#4caf50';
  };

  const safeValue = Number.isFinite(value) ? value : 0;
  const data = [{ value: safeValue, fill: getColor(safeValue) }];
  const valueColor = theme.palette.text.primary;
  const displayValue = Number.isFinite(value) ? `${value.toFixed(1)}%` : '--';

  return (
    <Card style={{ height: '100%' }}>
      <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom align="center">
          {label}
        </Typography>
        <Box
          position="relative"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={150}
          height={120}
        >
          <ResponsiveContainer width={150} height={120}>
            <RadialBarChart
              cx="50%" cy="100%"
              innerRadius="80%" outerRadius="100%"
              data={data}
              startAngle={180} endAngle={0}
            >
              <RadialBar
                background
                dataKey="value"
                cornerRadius={10}
              />
            </RadialBarChart>
          </ResponsiveContainer>
          <Box
            position="absolute"
            bottom={8}
            left="50%"
            style={{ transform: 'translateX(-50%)', zIndex: 1 }}
          >
            <Typography variant="h5" style={{ color: valueColor, fontWeight: 600 }}>
              {displayValue}
            </Typography>
          </Box>
        </Box>
        {subtitle && (
          <Typography
            variant="caption"
            color="textSecondary"
            align="center"
            display="block"
            style={{ marginTop: 8 }}
          >
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default GaugeChart;